
import React, { createContext, useContext, useMemo, useRef, useState, useEffect } from 'react';
import { PaletteColor, VariantProps } from '../interfaces/customElementsInterfaces';

export function useUpdateEffect(fn: (deps?: any[]) => void, deps: any[]): void {
    const didMount = useRef(false);

    useEffect(() => {
        if (didMount.current) {
            fn(deps);
        } else {
            didMount.current = true;
        }
    }, deps);
}

export const getPropsByVariant = ({ variant, color, theme, checked }: VariantProps & { variant: 'checked' | string }) => {
    const palette = (theme.palette as { [key: string]: PaletteColor })[color] ?? theme.palette;
    return {
        backgroundColor: checked ? palette.main : palette.hover,
        borderColor: palette.outline,
        color: palette.contrastText,
    };
};